import 'formdata-polyfill';

var AuthClientPersistenceOptions;
(function (AuthClientPersistenceOptions) {
    AuthClientPersistenceOptions["NONE"] = "none";
    AuthClientPersistenceOptions["LOCAL_STORAGE"] = "localStorage";
    AuthClientPersistenceOptions["SESSION_STORAGE"] = "sessionStorage";
})(AuthClientPersistenceOptions || (AuthClientPersistenceOptions = {}));
var OAuthGrantTypes;
(function (OAuthGrantTypes) {
    OAuthGrantTypes["AUTH_CODE"] = "authorization_code";
    OAuthGrantTypes["REFRESH_TOKEN"] = "refresh_token";
    OAuthGrantTypes["PASSWORD"] = "password";
})(OAuthGrantTypes || (OAuthGrantTypes = {}));
var OAuthStatusTypes;
(function (OAuthStatusTypes) {
    OAuthStatusTypes["IDLE"] = "idle";
    OAuthStatusTypes["PENDING"] = "pending";
    OAuthStatusTypes["ERROR"] = "error";
    OAuthStatusTypes["AUTHENTICATED"] = "authenticated";
})(OAuthStatusTypes || (OAuthStatusTypes = {}));

function getRegisteredGlobal(namespace, globalObj) {
    const target = (Array.isArray(namespace) ? namespace : namespace.split(".")).reduce((prev, curr) => (prev === null || prev === undefined ? undefined : prev[curr]), globalObj || (typeof window !== "undefined" ? window : global) || {});
    return typeof target === "undefined" ? undefined : target;
}

const globalNamespaceBase = "trumpf";
function registerGlobal(obj, namespace, globalObj) {
    const tree = Array.isArray(namespace) ? namespace : namespace.split(".");
    if (tree[0] !== globalNamespaceBase) {
        throw new Error("Invalid namespace");
    }
    let current = globalObj || (typeof window !== "undefined" ? window : global) || {};
    tree.forEach((part, index) => {
        if (index === tree.length - 1) {
            current[part] = obj;
        }
        else {
            current[part] = current[part] || {};
            current = current[part];
        }
    });
}

const BASE_NS = "trumpf.ux.authClient";
const DEFAULT_CLIENT_SCOPE = "global";
const DEFAULT_CLIENT_NS = BASE_NS + "." + DEFAULT_CLIENT_SCOPE;
const DEFAULT_CLIENT_PERSISTENCE = AuthClientPersistenceOptions.NONE;
const defaultAuthClientConfig = {
    namespace: DEFAULT_CLIENT_NS,
    persistenceType: DEFAULT_CLIENT_PERSISTENCE
};
const OP_IFRAME_ID = "ux-oauth-OP-iframe";
const RP_IFRAME_ID = "ux-oauth-RP-iframe";
const RP_POLL_INTERVAL = 2000;
const RP_IFRAME_SRCDOC_TPL = `<script type="text/javascript">
    window.poll = function () {
        var opIframe = window.parent.document.querySelector("iframe#OP_IFRAME_ID");
        if (opIframe && opIframe.contentWindow) {
            opIframe.contentWindow.postMessage("OP_IFRAME_MESSAGE", "OP_IFRAME_ORIGIN");
        }
    };
</script>`;

const strToBuffer = (str) => {
    const arrayBuffer = new ArrayBuffer(str.length);
    const uintArray = new Uint8Array(arrayBuffer);
    uintArray.forEach((_, i) => {
        uintArray[i] = str.charCodeAt(i);
    });
    return uintArray;
};
const base64UrlEncode = (str) => {
    return window.btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};
const getQueryString = (params) => {
    const queryParams = [];
    Object.entries(params).forEach(([key, value]) => {
        if (key === "url") {
            return;
        }
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParams.length > 0 ? queryParams.join("&") : "";
};
const getQueryParameter = (name, url = window.top?.location.href || window.location.href) => {
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
const getUrlOrigin = (url) => {
    const regex = new RegExp("^(https?:\\/\\/[^\\/?]+)");
    const results = regex.exec(url);
    if (!results) {
        return "";
    }
    return results[1];
};
const getRandomString = (size = 45) => {
    const unreserved = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let randomString = "";
    const crypto = window.crypto || window["msCrypto"];
    if (crypto) {
        const bytes = new Uint8Array(size);
        crypto.getRandomValues(bytes);
        const numbers = [];
        bytes.forEach((x, i) => {
            numbers[i] = unreserved.charCodeAt(x % unreserved.length);
        });
        randomString = String.fromCharCode.apply(null, numbers);
    }
    else {
        while (0 < size--) {
            randomString += unreserved[Math.floor(Math.random() * unreserved.length) | 0];
        }
    }
    return randomString;
};
const getCodeVerifier = () => {
    return base64UrlEncode(getRandomString(43));
};
const getCodeChallenge = async (codeVerifier) => {
    try {
        const digest = await crypto.subtle.digest("SHA-256", strToBuffer(codeVerifier));
        const digestBase64 = String.fromCharCode(...Array.from(new Uint8Array(digest)));
        return base64UrlEncode(digestBase64);
    }
    catch {
        return codeVerifier;
    }
};
const getJWTPayload = (token) => {
    if (!token?.length) {
        return null;
    }
    const base64Url = token.split(".")[1];
    if (!base64Url) {
        return null;
    }
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    try {
        return JSON.parse(window.atob(base64));
    }
    catch (error) {
        return null;
    }
};
const detectTokenExpirationTime = (data) => {
    if (data.expires_at) {
        return data.expires_at;
    }
    const jwt = getJWTPayload(data.id_token || null);
    if (jwt) {
        if (typeof jwt.exp === "number") {
            return jwt.exp;
        }
        if (typeof jwt.iat === "number" && data.expires_in > 0) {
            return jwt.iat + data.expires_in;
        }
    }
    return undefined;
};
const getBaseUrl = (url) => {
    if (typeof url !== "string") {
        return null;
    }
    const matches = /(https?:\/\/)([^?]+)(.*)/.exec(url);
    if (matches !== null) {
        return `${matches[1]}${matches[2]}`;
    }
    return null;
};
const getUrlOrCurrent = (url) => {
    if (typeof url === "string" && /^https?:\/\//.test(url)) {
        return url;
    }
    return window.top.location.href;
};

class AuthClient {
    accessToken = null;
    authData = null;
    config;
    observers = [];
    constructor(options) {
        this.config = {
            ...defaultAuthClientConfig,
            ...options
        };
        this.init();
    }
    init() {
        const { namespace } = this.config;
        const storage = this.getStorage();
        const storedValue = storage ? storage.getItem(namespace) : null;
        if (storedValue) {
            try {
                const storedData = JSON.parse(storedValue);
                if (storedData.access_token) {
                    this.accessToken = storedData.access_token;
                    this.authData = storedData;
                    const exp = detectTokenExpirationTime(storedData) || 0;
                    if (exp > 0) {
                        if (exp > Math.floor(new Date().getTime() / 1000)) {
                            this.authData.expires_at = exp;
                        }
                        else {
                            this.accessToken = null;
                            this.authData = null;
                        }
                    }
                }
            }
            catch {
            }
            this.updateStorage();
        }
    }
    getStorage() {
        if (typeof window === "undefined") {
            return null;
        }
        switch (this.config.persistenceType) {
            case AuthClientPersistenceOptions.LOCAL_STORAGE:
                return window.localStorage;
            case AuthClientPersistenceOptions.SESSION_STORAGE:
                return window.sessionStorage;
            default:
                return null;
        }
    }
    updateStorage() {
        const { namespace } = this.config;
        const storage = this.getStorage();
        if (storage === null) {
            return;
        }
        const data = this.authData ? this.authData : this.accessToken ? { access_token: this.accessToken } : null;
        if (!data?.access_token) {
            storage.removeItem(namespace);
            return;
        }
        const jsonString = JSON.stringify(data);
        storage.setItem(namespace, jsonString);
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this.accessToken);
            }
            catch {
            }
        });
    }
    getAccessToken() {
        return this.accessToken;
    }
    setAccessToken(token) {
        if (!token?.length) {
            return false;
        }
        if (token === this.accessToken) {
            return true;
        }
        this.accessToken = token;
        this.authData = null;
        this.updateStorage();
        this.notifyObservers();
        return true;
    }
    deleteAccessToken() {
        if (this.accessToken === null) {
            return;
        }
        this.accessToken = null;
        this.authData = null;
        this.updateStorage();
        this.notifyObservers();
    }
    getTokenData() {
        return this.authData;
    }
    getTokenExpiration() {
        return this.authData ? detectTokenExpirationTime(this.authData) : undefined;
    }
    setTokenData(data) {
        if (!data?.access_token || data.access_token === this.accessToken) {
            return;
        }
        this.authData = data;
        this.accessToken = data.access_token;
        if (!this.authData.expires_at) {
            const exp = detectTokenExpirationTime(data) || 0;
            if (exp > 0) {
                this.authData.expires_at = exp;
            }
        }
        this.updateStorage();
        this.notifyObservers();
    }
    getRefreshToken() {
        return this.authData ? this.authData.refresh_token || null : null;
    }
    getIdToken() {
        return this.authData ? this.authData.id_token || null : null;
    }
    getIdTokenPayload() {
        return getJWTPayload(this.getIdToken());
    }
    subscribe(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
        }
        if (this.accessToken) {
            observer(this.accessToken);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
    async getAccessTokenAsync() {
        return new Promise((resolve) => {
            if (this.accessToken) {
                resolve(this.accessToken);
            }
            else {
                const unsubscribe = this.subscribe((token) => {
                    if (token) {
                        unsubscribe();
                        resolve(token);
                    }
                });
            }
        });
    }
    async getTokenDataAsync() {
        return new Promise((resolve) => {
            if (this.authData) {
                resolve(this.authData);
            }
            else {
                const unsubscribe = this.subscribe(() => {
                    if (this.authData) {
                        unsubscribe();
                        resolve(this.authData);
                    }
                });
            }
        });
    }
}

function getAuthClient(scopeOrOptions) {
    let namespace = DEFAULT_CLIENT_NS;
    let persistenceType = DEFAULT_CLIENT_PERSISTENCE;
    if (scopeOrOptions) {
        if (typeof scopeOrOptions === "string") {
            namespace = BASE_NS + "." + scopeOrOptions;
        }
        else {
            if (scopeOrOptions.namespace) {
                namespace = scopeOrOptions.namespace;
            }
            else if (scopeOrOptions.globalNamespace) {
                namespace = scopeOrOptions.globalNamespace;
            }
            if (scopeOrOptions.persistenceType) {
                persistenceType = scopeOrOptions.persistenceType;
            }
        }
    }
    let client = getRegisteredGlobal(namespace, window);
    if (client === undefined) {
        client = new AuthClient({
            namespace,
            persistenceType
        });
        registerGlobal(client, namespace);
    }
    return client;
}

var TrumpfEnvNames;
(function (TrumpfEnvNames) {
    TrumpfEnvNames["PROD"] = "prod";
    TrumpfEnvNames["QA"] = "qa";
})(TrumpfEnvNames || (TrumpfEnvNames = {}));

const nsEnvName = "trumpf.ux.env.name";

function getEnv() {
    return getRegisteredGlobal(nsEnvName) || TrumpfEnvNames.PROD;
}

function setEnv(env) {
    if (typeof env === "undefined") {
        return false;
    }
    const currentEnv = getRegisteredGlobal(nsEnvName);
    if (env === currentEnv) {
        return true;
    }
    switch (env.valueOf()) {
        case TrumpfEnvNames.PROD.valueOf():
        case TrumpfEnvNames.QA.valueOf():
            registerGlobal(env, nsEnvName);
            return true;
        default:
            return false;
    }
}

var configProd = {
    websiteBaseUrl: "https://www.trumpf.com",
    websitePaths: {
        home: "/",
        mytrumpf: "/mytrumpf",
        userProfile: "/?id=861"
    },
    authApiBaseUrl: "https://identity.trumpf.com/oauth2",
    iHubApiBaseUrl: "https://api-p.trumpf.com",
    iHubApiEndpoints: {
        selfService: "/selfservice/2.1"
    }
};

var configQA = {
    websiteBaseUrl: "https://www-q.trumpf.com",
    websitePaths: {
        home: "/",
        mytrumpf: "/mytrumpf",
        userProfile: "/?id=861"
    },
    authApiBaseUrl: "https://identity-s.trumpf.com/oauth2",
    iHubApiBaseUrl: "https://api-s.trumpf.com",
    iHubApiEndpoints: {
        selfService: "/selfservice/2.1"
    }
};

function getConfig() {
    switch (getEnv()) {
        case TrumpfEnvNames.QA.valueOf():
            return configQA;
        case TrumpfEnvNames.PROD.valueOf():
        default:
            return configProd;
    }
}

class OAuth2Iframe {
    config;
    callback;
    _opOrigin;
    _rpWindow = null;
    _rpInterval = null;
    constructor(config, onStatus) {
        this.config = { ...config };
        this._opOrigin = getUrlOrigin(this.config.checkSessionUri);
        this.callback = onStatus;
        this.initIframes();
    }
    initIframes() {
        let opIframe = this.getOPIframe();
        if (opIframe !== null) {
            opIframe.removeEventListener("load", this.handleIframeLoad);
            opIframe.remove();
        }
        opIframe = document.createElement("iframe");
        opIframe.id = OP_IFRAME_ID;
        opIframe.src = `${this.config.checkSessionUri}?${getQueryString({
            client_id: this.config.clientId,
            redirect_uri: this.config.redirectUri
        })}`;
        opIframe.addEventListener("load", this.handleIframeLoad);
        applyHiddenIframeStyles(opIframe);
        document.body.appendChild(opIframe);
        let rpIframe = this.getRPIframe();
        if (rpIframe !== null) {
            rpIframe.removeEventListener("load", this.handleIframeLoad);
            rpIframe.remove();
        }
        rpIframe = document.createElement("iframe");
        rpIframe.id = RP_IFRAME_ID;
        rpIframe.srcdoc = getRPIframeSrcdoc(this.config);
        rpIframe.addEventListener("load", this.handleIframeLoad);
        applyHiddenIframeStyles(rpIframe);
        document.body.appendChild(rpIframe);
    }
    destroy() {
        this.stopPoll();
        const opIframe = this.getOPIframe();
        if (opIframe !== null) {
            opIframe.removeEventListener("load", this.handleIframeLoad);
            opIframe.remove();
        }
        const rpIframe = this.getRPIframe();
        if (rpIframe !== null) {
            rpIframe.removeEventListener("load", this.handleIframeLoad);
            rpIframe.remove();
        }
    }
    getOPIframe() {
        return document.querySelector(`iframe#${OP_IFRAME_ID}`);
    }
    getRPIframe() {
        return document.querySelector(`iframe#${RP_IFRAME_ID}`);
    }
    getRPWindow() {
        return this.getRPIframe()?.contentWindow || null;
    }
    startPoll() {
        this.stopPoll();
        const rpWin = this.getRPWindow();
        if (rpWin !== null) {
            this._rpWindow = rpWin;
            this._rpWindow.addEventListener("message", this.handleIframeMessage, true);
            this._rpInterval = window.setInterval(() => {
                try {
                    rpWin.poll();
                }
                catch {
                    this.stopPoll();
                }
            }, Math.max(this.config.checkSessionInterval || RP_POLL_INTERVAL, 500));
        }
    }
    stopPoll() {
        if (this._rpInterval !== null) {
            window.clearInterval(this._rpInterval);
            this._rpInterval = null;
        }
        if (this._rpWindow !== null) {
            this._rpWindow.removeEventListener("message", this.handleIframeMessage);
            this._rpWindow = null;
        }
    }
    handleIframeLoad = () => {
        if (this.getRPWindow() !== null) {
            this.startPoll();
        }
    };
    handleIframeMessage = (e) => {
        if (e.origin !== this._opOrigin) {
            return;
        }
        switch (e.data) {
            case "unchanged":
                this.callback(e.data);
                break;
            case "changed":
            case "error":
                this.stopPoll();
                this.callback(e.data);
                break;
        }
    };
}
const applyHiddenIframeStyles = (el) => {
    el.style.position = "absolute";
    el.style.border = "0 none transparent";
    el.style.left = "-1000px";
    el.style.top = "-1000px";
    el.style.width = "1px";
    el.style.height = "1px";
};
const getRPIframeSrcdoc = (config) => {
    const opIframeOrigin = getUrlOrigin(config.checkSessionUri);
    return RP_IFRAME_SRCDOC_TPL.replace("OP_IFRAME_MESSAGE", `${config.clientId} ${config.sessionState}`)
        .replace("OP_IFRAME_ORIGIN", opIframeOrigin)
        .replace("OP_IFRAME_ID", OP_IFRAME_ID);
};

const lsNamespace = "trumpf.ux.oauth2Client";
class OAuth2Client {
    config;
    observers = [];
    _authClient = getAuthClient();
    _authCode = null;
    _authData = null;
    _authError = null;
    _localStorageData;
    _redirectUri;
    _sessionState = null;
    _sessionIframe = null;
    _status = OAuthStatusTypes.IDLE;
    constructor(config) {
        const { authApiBaseUrl } = getConfig();
        this._localStorageData = this.getLocalStorageData();
        this._authData = this.getLocalStorageAuth();
        this._redirectUri = this._localStorageData.redirectUri || config.redirectUri || null;
        this.config = {
            issuer: config.apiUrl || authApiBaseUrl,
            scope: "openid",
            ...config
        };
        this.init();
    }
    init() {
        if (this._authData !== null && typeof this._authData.redirect_uri === "string") {
            this._redirectUri = this._authData.redirect_uri;
        }
        const state = getQueryParameter("state");
        if (state !== null && state === this._localStorageData.state) {
            const authCode = getQueryParameter("code");
            if (authCode !== null) {
                this._authCode = authCode;
                this._sessionState = getQueryParameter("session_state");
                this.requestTokenWithAuthCode();
                return;
            }
            if (getQueryParameter("logged_out") !== null) {
                this.deleteAccessToken();
                return;
            }
        }
        if (this._authData !== null && this._authData.access_token && this._authData.session_state) {
            const expiresAt = this.getTokenExpiration();
            if (expiresAt <= 0 || expiresAt > new Date().getTime()) {
                this._sessionState = this._authData.session_state;
                this._status = OAuthStatusTypes.AUTHENTICATED;
                this.initSessionIframe();
                return;
            }
        }
        this._authData = null;
        this._authError = null;
        this._status = OAuthStatusTypes.IDLE;
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this);
            }
            catch {
            }
        });
    }
    subscribe(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
    getError() {
        return this._authError;
    }
    getStatus() {
        return this._status;
    }
    getAccessToken() {
        return this._authClient.getAccessToken();
    }
    setAccessToken(token) {
        const prevToken = this.getAccessToken();
        if (this._authClient.setAccessToken(token)) {
            if (this.getAccessToken() !== prevToken) {
                this.notifyObservers();
            }
            return true;
        }
        return false;
    }
    deleteAccessToken() {
        const prevToken = this.getAccessToken();
        this._authClient.deleteAccessToken();
        this.revokeAuthentication();
        if (prevToken !== null) {
            this.notifyObservers();
        }
    }
    getTokenExpiration() {
        if (this._authData !== null && typeof this._authData.expires_at === "number") {
            return this._authData.expires_at;
        }
        return 0;
    }
    async requestAuthCode() {
        return this.login();
    }
    async login(loginRedirectUri) {
        const { issuer, clientId, scope } = this.config;
        const codeVerifier = getCodeVerifier();
        const codeChallenge = await getCodeChallenge(codeVerifier);
        const redirectUri = getUrlOrCurrent(loginRedirectUri || this.config.redirectUri);
        const data = {
            client_id: clientId,
            response_type: "code",
            redirect_uri: redirectUri,
            state: this.createStateHash(),
            scope: scope,
            code_challenge: codeChallenge,
            code_challenge_method: "S256"
        };
        this.updateLocalStorageData({
            ...this._localStorageData,
            codeVerifier,
            redirectUri
        });
        this.destroySessionIframe();
        window.top.location.assign(`${issuer}/authorize?${getQueryString(data)}`);
    }
    async requestTokenWithAuthCode() {
        const { clientId, scope } = this.config;
        const data = {
            grant_type: OAuthGrantTypes.AUTH_CODE,
            response_type: "token",
            code: this._authCode,
            redirect_uri: this._redirectUri,
            client_id: clientId,
            scope: scope,
            code_verifier: this._localStorageData.codeVerifier
        };
        this._status = OAuthStatusTypes.PENDING;
        this.destroySessionIframe();
        return this.sendTokenRequest(data);
    }
    async loginWithCredentials({ username, password }) {
        const { clientId, clientSecret, scope } = this.config;
        const data = {
            client_id: clientId,
            client_secret: clientSecret,
            grant_type: OAuthGrantTypes.PASSWORD,
            scope: scope,
            username: username,
            password: password
        };
        this._status = OAuthStatusTypes.PENDING;
        this.destroySessionIframe();
        return this.sendTokenRequest(data);
    }
    async refreshToken() {
        const { clientId } = this.config;
        if (!this._authData?.refresh_token) {
            throw new Error("No refresh_token");
        }
        this.destroySessionIframe();
        const data = {
            client_id: clientId,
            grant_type: OAuthGrantTypes.REFRESH_TOKEN,
            refresh_token: this._authData.refresh_token
        };
        return this.sendTokenRequest(data);
    }
    async logout() {
        if (this._status !== OAuthStatusTypes.AUTHENTICATED) {
            this.deleteAccessToken();
            return;
        }
        const logoutBaseUrl = getBaseUrl(this.config.logoutUri);
        if (logoutBaseUrl === null) {
            this.deleteAccessToken();
            return;
        }
        const postLogoutRedirectUri = getUrlOrCurrent(this.config.postLogoutRedirectUri);
        const queryPrefix = !postLogoutRedirectUri.includes("?") ? "?" : "&";
        const logoutUrl = `${logoutBaseUrl}?${getQueryString({
            prompt: "none",
            id_token_hint: this._authData.id_token,
            post_logout_redirect_uri: `${postLogoutRedirectUri}${queryPrefix}${getQueryString({
                logged_out: "",
                state: this.createStateHash()
            })}`
        })}`;
        window.top.location.assign(logoutUrl);
    }
    sendTokenRequest = (data) => {
        const { issuer } = this.config;
        this._status = OAuthStatusTypes.PENDING;
        this._authError = null;
        return fetch(`${issuer}/token`, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            redirect: "follow",
            body: getQueryString(data)
        })
            .then((response) => response.json())
            .then((data) => {
            this._status = OAuthStatusTypes.IDLE;
            if (data.access_token) {
                this.handleTokenResponse(data);
            }
            else if (data.error) {
                this.handleErrorResponse(data);
            }
            this.notifyObservers();
            return data;
        });
    };
    handleErrorResponse = (authError) => {
        this.flushLocalStorageAuth();
        this.flushLocalStorageData();
        this._status = OAuthStatusTypes.ERROR;
        this._authError = authError;
        this._authData = null;
    };
    handleTokenResponse = (authData) => {
        this.flushLocalStorageAuth();
        this.flushLocalStorageData();
        this._status = OAuthStatusTypes.AUTHENTICATED;
        this._authCode = null;
        this._authData = {
            ...this._authData,
            ...authData,
            expires_at: Date.now() + authData.expires_in * 1000,
            redirect_uri: this._redirectUri || undefined,
            session_state: this._sessionState
        };
        localStorage.setItem(`${lsNamespace}.auth`, JSON.stringify(this._authData));
        this._authClient.setTokenData(authData);
        this.initSessionIframe();
    };
    revokeAuthentication = () => {
        this._authData = null;
        this._authError = null;
        this._status = OAuthStatusTypes.IDLE;
        this.destroySessionIframe();
        this.flushLocalStorageData();
        this.flushLocalStorageAuth();
    };
    getLocalStorageAuth = () => {
        const jsonStr = localStorage.getItem(`${lsNamespace}.auth`);
        if (jsonStr === null) {
            return null;
        }
        try {
            return JSON.parse(jsonStr);
        }
        catch {
            localStorage.removeItem(`${lsNamespace}.auth`);
            return null;
        }
    };
    getLocalStorageData = () => {
        const jsonStr = localStorage.getItem(`${lsNamespace}.data`);
        const data = {
            state: null,
            codeVerifier: null,
            redirectUri: null,
            ...(jsonStr !== null ? JSON.parse(jsonStr) : {})
        };
        this._localStorageData = data;
        return data;
    };
    updateLocalStorageData = (data) => {
        this._localStorageData = data;
        const jsonStr = JSON.stringify(this._localStorageData, null, "");
        localStorage.setItem(`${lsNamespace}.data`, jsonStr);
        return this._localStorageData;
    };
    flushLocalStorageData = () => {
        localStorage.removeItem(`${lsNamespace}.data`);
    };
    flushLocalStorageAuth = () => {
        localStorage.removeItem(`${lsNamespace}.auth`);
    };
    createStateHash = () => {
        this.updateLocalStorageData({
            ...this._localStorageData,
            state: Math.random().toString(36).slice(2)
        });
        return this._localStorageData.state;
    };
    handleSessionIframeStatus = (status) => {
        if (status === "changed" && this._status === OAuthStatusTypes.AUTHENTICATED) {
            this.deleteAccessToken();
        }
    };
    destroySessionIframe = () => {
        if (this._sessionIframe) {
            this._sessionIframe.destroy();
            this._sessionIframe = null;
        }
    };
    getSessionIframe = () => {
        return this._sessionIframe;
    };
    initSessionIframe = () => {
        const { checkSessionUri, clientId } = this.config;
        this.destroySessionIframe();
        if (this._sessionState === null || this._redirectUri === null || !checkSessionUri) {
            return;
        }
        this._sessionIframe = new OAuth2Iframe({
            checkSessionUri,
            clientId,
            redirectUri: this._redirectUri,
            sessionState: this._sessionState
        }, this.handleSessionIframeStatus);
    };
}

const NAMESPACE = "trumpf.ux.errorDispatcher";
const DEFAULT_SCOPE = "global";
let subscriberIncrement = 0;
const createSubscriberId = () => `error-subscriber-${++subscriberIncrement}`;
class ErrorDispatcher {
    subscribers = {};
    notifySubscribers = (error) => {
        Object.values(this.subscribers).forEach((handler) => { handler(error); });
    };
    dispatchError(error) {
        this.notifySubscribers(error);
    }
    subscribe(handler) {
        const subscriberId = createSubscriberId();
        this.subscribers[subscriberId] = handler;
        return subscriberId;
    }
    unsubscribe(subscriberId) {
        delete this.subscribers[subscriberId];
    }
}
const getErrorDispatcher = (scope) => {
    const ns = `${NAMESPACE}.${scope || DEFAULT_SCOPE}`;
    let dispatcher = getRegisteredGlobal(ns) || null;
    if (dispatcher === null) {
        dispatcher = new ErrorDispatcher();
        registerGlobal(dispatcher, ns);
    }
    return dispatcher;
};

function getAttributes(element) {
    if (!element) {
        return {};
    }
    const nodeMap = element.attributes;
    const length = nodeMap.length;
    return Object.keys(nodeMap).reduce((props, current) => {
        try {
            const numCurrent = parseInt(current);
            if (numCurrent <= length) {
                const property = nodeMap[current];
                return {
                    ...props,
                    [property.name]: property.value
                };
            }
        }
        catch (err) {
        }
    }, {});
}

const getSvg = (width, height) => `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" style="background: #e7e7e7">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-22.4 -37.5 135 165">
            <path fill="#a1a1a1" d="M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"/>
        </svg>
    </svg>
`;
const convertToUrl = (input) => `data:image/svg+xml,${encodeURIComponent(input).replace(/%20/g, " ").replace(/%0A/g, "").replace(/\s\s+/g, " ").trim()}`;
const getImageUrlPlaceholder = (width, height) => convertToUrl(getSvg(width, height));

const isJsonString = (str) => {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};

function decodeJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""));
    return JSON.parse(jsonPayload);
}

const serializeForm = (formElement) => {
    if (formElement === null) {
        return "";
    }
    return Array.from(new FormData(formElement), (e) => e.map(encodeURIComponent).join("=")).join("&");
};

let subscriberIncrementId = 0;
class SharedStore {
    name;
    store = {};
    subscribers = {};
    subscriptions = {};
    constructor(storeName) {
        this.name = storeName;
        let storageItem = null;
        if (typeof localStorage !== "undefined") {
            storageItem = localStorage.getItem(this.name);
        }
        if (storageItem !== null && isJsonString(storageItem)) {
            this.store = JSON.parse(storageItem);
        }
    }
    notifySubscribers = (name, value, previousValue) => {
        if (!(name in this.subscriptions) || previousValue === value) {
            return;
        }
        this.subscriptions[name].forEach((id) => {
            this.subscribers[id]({
                name,
                value
            });
        });
    };
    persistStore = () => {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem(this.name, JSON.stringify(this.store));
        }
    };
    getValue(name) {
        return this.store[name];
    }
    setValue(name, value) {
        const previousValue = this.store[name];
        this.store[name] = value;
        this.notifySubscribers(name, value, previousValue);
        this.persistStore();
    }
    subscribe(names, callback) {
        const storeNames = Array.isArray(names) ? names : [names];
        const subscriberId = `store__${this.name}--${++subscriberIncrementId}`;
        this.subscribers[subscriberId] = callback;
        storeNames.forEach((name) => {
            this.subscriptions[name] = [...(this.subscriptions[name] || []), subscriberId];
        });
        return subscriberId;
    }
    unsubscribe(subscriberId) {
        delete this.subscribers[subscriberId];
        Object.keys(this.subscriptions).forEach((key) => {
            this.subscriptions[key] = this.subscriptions[key].filter((id) => id !== subscriberId);
        });
    }
}

function getSharedStore(name) {
    if (!name) {
        throw new Error("sharedStore requires a name");
    }
    const storeFullName = `trumpf.ux.sharedStores.${name}`;
    const existingStore = getRegisteredGlobal(storeFullName);
    if (existingStore) {
        return existingStore;
    }
    const store = new SharedStore(storeFullName);
    registerGlobal(store, storeFullName);
    return store;
}

var SharedStoreNames;
(function (SharedStoreNames) {
    SharedStoreNames["GLOBAL"] = "global";
})(SharedStoreNames || (SharedStoreNames = {}));

async function getTrumpfUser(token) {
    const accessToken = token !== undefined ? token : getAuthClient().getAccessToken();
    if (accessToken === null) {
        return null;
    }
    try {
        const config = getConfig();
        const result = await fetch(`${config.iHubApiBaseUrl}${config.iHubApiEndpoints.selfService}`, {
            method: "GET",
            keepalive: true,
            headers: {
                Accept: "application/json, text/plain, */*",
                Authorization: `Bearer ${accessToken}`
            }
        });
        return (await result.json());
    }
    catch (e) {
        return null;
    }
}

function transformTrumpfUserData(user) {
    const userEmail = user.emails?.[0] ? user.emails[0].value || "" : "";
    const userName = user.userName || userEmail;
    return {
        displayName: userName,
        email: userEmail,
        locale: user.locale || "",
        role: user.roles?.[0] ? user.roles[0] : "",
        userId: user.id || "",
        userName: userName
    };
}

class TrumpfUserClient {
    userData = null;
    pendingRequest = false;
    observers = [];
    constructor() {
        getAuthClient().subscribe(() => {
            this.getUserData(true);
        });
    }
    async requestUserData() {
        if (this.pendingRequest !== false) {
            return this.pendingRequest;
        }
        this.pendingRequest = getTrumpfUser();
        this.userData = await this.pendingRequest;
        this.notifyObservers();
        this.pendingRequest = false;
        return this.userData;
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this.userData);
            }
            catch {
            }
        });
    }
    async getUserData(reload) {
        return this.userData !== null && reload !== true ? this.userData : this.requestUserData();
    }
    getBaseUser() {
        if (this.userData !== null) {
            return transformTrumpfUserData(this.userData);
        }
        return null;
    }
    subscribe(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
}

const globalNamespace = "trumpf.ux.apiUserClient";
function getTrumpfUserClient() {
    let client = getRegisteredGlobal(globalNamespace, window);
    if (client === undefined) {
        client = new TrumpfUserClient();
        registerGlobal(client, globalNamespace);
    }
    return client;
}

const WIDGET_FILTER_PROVIDER_NAMESPACE = "trumpf.ux.widgetFilterProvider";
const WIDGET_REGISTRY_NAMESPACE = "trumpf.ux.widgetRegistry";
const WIDGET_REGISTRY_SCOPE_GLOBAL = "global";

class WidgetFilterProvider {
    _name;
    _store;
    constructor(name) {
        this._name = name;
        this._store = getSharedStore(`widgetFilterProvider.${this._name}`);
    }
    getFilter(filterName) {
        return this._store.getValue(filterName) || null;
    }
    setFilter(filterName, filterValue) {
        let filter = this.getFilter(filterName);
        if (filter !== null && filter.filterValue === filterValue) {
            return filter;
        }
        filter = {
            filterName,
            filterValue
        };
        this._store.setValue(filterName, filter);
        return filter;
    }
    subscribe(filterName, callback) {
        const filterNames = Array.isArray(filterName) ? filterName : [filterName];
        return this._store.subscribe(filterNames, ({ value }) => {
            callback(value);
        });
    }
    unsubscribe(subscriberId) {
        this._store.unsubscribe(subscriberId);
    }
}
function getWidgetFilterProvider(name = "global") {
    const ns = `${WIDGET_FILTER_PROVIDER_NAMESPACE}.${name}`;
    let provider = getRegisteredGlobal(ns);
    if (provider === undefined) {
        provider = new WidgetFilterProvider(name);
        registerGlobal(provider, ns);
    }
    return provider;
}

class WidgetRegistry {
    widgets = {};
    registerWidget(type, tagName, config) {
        this.widgets[type] = {
            type,
            tagName,
            config: config || {}
        };
    }
    getWidgetDefinition(type) {
        if (typeof this.widgets[type] !== "object") {
            throw Error(`getWidgetDefinition Error: no widget registered for type ${type}`);
        }
        return this.widgets[type];
    }
    getRegisteredWidgets() {
        return Object.keys(this.widgets).map((type) => this.widgets[type]);
    }
}
function getWidgetRegistry(scope) {
    const scopeName = scope || WIDGET_REGISTRY_SCOPE_GLOBAL;
    const namespace = `${WIDGET_REGISTRY_NAMESPACE}.${scopeName}`;
    let registry = getRegisteredGlobal(namespace);
    if (registry === undefined) {
        registry = new WidgetRegistry();
        registerGlobal(registry, namespace);
    }
    return registry;
}
function registerWidget(type, tagName, config) {
    getWidgetRegistry().registerWidget(type, tagName, config);
}
function getWidgetDefinition(type) {
    return getWidgetRegistry().getWidgetDefinition(type);
}

let widgetSettingSubscriptionIncrementId = 1;
class WidgetSettingProvider {
    _config;
    _subscriptions;
    _data;
    constructor(config) {
        this._config = {
            ...config
        };
        this._subscriptions = {};
        this._data = null;
        if (this.widgetAttributeName) {
            this.readWidgetAttribute();
            this.widgetElement.addEventListener("uxcWidgetSettings", this.handleWidgetSettings);
        }
    }
    get widgetElement() {
        return this._config.widgetElement;
    }
    get widgetAttributeName() {
        return this._config.widgetAttributeName || null;
    }
    getData() {
        return this._data;
    }
    setData(data) {
        if (data === this._data) {
            return;
        }
        this._data = data;
        this.updateWidgetAttribute();
        this.notifySubscribers();
    }
    subscribe(callback) {
        const subscriberId = `widget-setting-subscription--${++widgetSettingSubscriptionIncrementId}`;
        this._subscriptions[subscriberId] = callback;
        return subscriberId;
    }
    unsubscribe(subscriberId) {
        if (this._subscriptions[subscriberId]) {
            delete this._subscriptions[subscriberId];
        }
    }
    notifySubscribers = () => {
        const data = this._data;
        Object.values(this._subscriptions).forEach((callback) => {
            try {
                callback(data);
            }
            catch (err) {
            }
        });
    };
    readWidgetAttribute() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" || !(widgetElement instanceof HTMLElement)) {
            return;
        }
        this.setData(this.parseWidgetAttribute());
    }
    updateWidgetAttribute() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" || !(widgetElement instanceof HTMLElement)) {
            return;
        }
        const oldValue = this.getWidgetAttributeValue();
        const newValue = this.serializeData();
        if (newValue !== oldValue) {
            widgetElement.setAttribute(widgetAttributeName, newValue);
            widgetElement.dispatchEvent(new CustomEvent("uxcWidgetSettings", {
                bubbles: true,
                cancelable: false,
                detail: {
                    name: widgetAttributeName,
                    value: newValue
                }
            }));
        }
    }
    getWidgetAttributeValue() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" || !(widgetElement instanceof HTMLElement)) {
            return "";
        }
        return widgetElement.getAttribute(widgetAttributeName) || "";
    }
    parseWidgetAttribute() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" || !(widgetElement instanceof HTMLElement)) {
            return null;
        }
        const value = this.getWidgetAttributeValue();
        if (!value || value.length === 0) {
            return null;
        }
        try {
            return JSON.parse(value);
        }
        catch {
            return null;
        }
    }
    serializeData() {
        if (this._data) {
            try {
                return JSON.stringify(this._data);
            }
            catch {
                return "";
            }
        }
        return "";
    }
    handleWidgetSettings = (event) => {
        const { detail } = event;
        const { widgetAttributeName } = this;
        if (detail.name === widgetAttributeName && detail.value !== this.serializeData()) {
            this.readWidgetAttribute();
        }
    };
}

class WidgetFilterSettingProvider extends WidgetSettingProvider {
    _menuItems;
    constructor({ widgetElement, widgetAttributeName = "filter", menuItems }) {
        super({
            widgetElement,
            widgetAttributeName
        });
        this._menuItems = Array.isArray(menuItems) ? menuItems : [];
    }
    getFilter() {
        return this.getData();
    }
    setFilter(value) {
        this.setData(value);
    }
    async getTags() {
        return [];
    }
    getMenuItems() {
        return this._menuItems;
    }
    selectMenuItem(_item) {
    }
}

const waitForHydrated = (element, callback) => {
    if (element.classList.contains("hydrated")) {
        callback();
        return;
    }
    const observer = new MutationObserver((mutations) => { _processMutations(mutations, element, callback, observer); });
    observer.observe(element, { attributes: true });
};
const _processMutations = (mutations, element, callback, observer) => {
    mutations.forEach(({ attributeName }) => {
        if (attributeName == "class" && element.classList.contains("hydrated")) {
            callback();
            observer.disconnect();
        }
    });
};

export { AuthClient, AuthClientPersistenceOptions, ErrorDispatcher, OAuth2Client, OAuthGrantTypes, OAuthStatusTypes, SharedStoreNames, TrumpfUserClient, WidgetFilterSettingProvider, WidgetSettingProvider, convertToUrl, decodeJwt, getAttributes, getAuthClient, getConfig, getEnv, getErrorDispatcher, getImageUrlPlaceholder, getRegisteredGlobal, getSharedStore, getSvg, getTrumpfUser, getTrumpfUserClient, getWidgetDefinition, getWidgetFilterProvider, getWidgetRegistry, isJsonString, registerGlobal, registerWidget, serializeForm, setEnv, transformTrumpfUserData, waitForHydrated };
//# sourceMappingURL=index.js.map
